import { Button, useToast } from "@helmr/ui";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { createTask } from "../../api/tasks";
import { useServices } from "../../app/services";
import { fu } from "./strings";
import { TITLE_MAX } from "./TasksPage";
import type { Scope } from "./hooks";
import s from "./followups.module.css";

/** "Add a task about this person": a staff task linked to a lead or member, for a profile page to mount. */
export function LinkedTaskForm({ sc, link }: { sc: Scope; link: { type: "lead" | "member"; id: string } }) {
  const { client } = useServices();
  const qc = useQueryClient();
  const toast = useToast();
  const [title, setTitle] = useState("");
  const [due, setDue] = useState(sc.date);
  const [busy, setBusy] = useState(false);
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const text = title.trim();
    if (!text || busy) return;
    setBusy(true);
    try {
      await createTask(client, { title: text.slice(0, TITLE_MAX), dueDate: due || null, link, ...(sc.branchId ? { branchId: sc.branchId } : {}) });
      setTitle("");
      toast.show("Task added");
      void qc.invalidateQueries({ queryKey: ["tasks"] });
    } catch { toast.show(fu.tasks.addFailed); } finally { setBusy(false); }
  }
  return (
    <form className={s.qadd} onSubmit={submit}>
      <input value={title} maxLength={TITLE_MAX} onChange={(e) => setTitle(e.target.value)} placeholder="Add a task about this lead" aria-label="Task about this lead" autoComplete="off" />
      <input type="date" value={due} onChange={(e) => setDue(e.target.value)} aria-label={fu.tasks.due} />
      <Button size="sm" type="submit" busy={busy} busyLabel={fu.tasks.adding}>{fu.tasks.add}</Button>
    </form>
  );
}
